import { To } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';

export function stringOfTo(to: To) {
    if (typeof to === 'string') return to;

    const pathname = to.pathname ?? '';
    const search = to.search ? (to.search.startsWith('?') ? to.search : `?${to.search}`) : '';
    const hash = to.hash ? (to.hash.startsWith('#') ? to.hash : `#${to.hash}`) : '';

    return `${pathname}${search}${hash}`;
}

export function linkTo(
    pathname: string,
    params?: string | Record<string, string | undefined | Record<string, string>>,
): To {
    // NOTE: clean { key: undefined } params
    const sanitized =
        typeof params === 'object'
            ? new URLSearchParams(
                  Object.entries(params ?? {}).reduce(
                      (obj, [key, value]) => {
                          if (value === undefined) return obj;

                          obj[key] = typeof value === 'string' ? value : JSON.stringify(value);
                          return obj;
                      },
                      {} as Record<string, string>,
                  ),
              ).toString()
            : params;

    return {
        pathname,
        search: sanitized ? sanitized : undefined,
    };
}

export function linkToCurrentLocation(withSearch = true): To {
    return {
        pathname: window.location.pathname,
        search: withSearch ? window.location.search : undefined,
    };
}

export function callbackUrlFromCurrentLocation() {
    const path = `${window.location.pathname}${window.location.search ?? ''}`;

    return [ROUTES.login.route, ROUTES.root.route].includes(window.location.pathname) ? undefined : path;
}
